

























import { Vue, Component, Prop } from 'vue-property-decorator'
import { popup } from '@lx-frontend/cvux'
import SearchInput from '../../components/SearchInput.vue'
import { CommonSelectItem } from '../indexType'

@Component({
  components: {
    popup,
    SearchInput
  }
})
export default class OutTipsPopup extends Vue {
  @Prop(Number) readonly id!: number;
  @Prop(Array) readonly list!: CommonSelectItem[];

  keyword = ''

  show = false

  handleSelect(option: CommonSelectItem) {
    this.$emit('select', option)
    this.changeShow(false)
  }

  get options() {
    const { keyword } = this
    if (keyword) {
      return this.list.filter(reason => reason.name.includes(keyword))
    }
    return this.list
  }

  changeShow(v:boolean) {
    if (v) {
      this.keyword = ''
    }
    this.show = v
  }
}
